// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics} from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCuknMh9yfeMPzqPK4qVboSnTDs8zihucc",
  authDomain: "portfolio-cch.firebaseapp.com",
  projectId: "portfolio-cch",
  storageBucket: "portfolio-cch.appspot.com",
  messagingSenderId: "357844899364",
  appId: "1:357844899364:web:3b36bb1d4323c502286ab1",
  measurementId: "G-KVCHFR4E7T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
 const analytics = getAnalytics(app);

 export default analytics